import { render, staticRenderFns } from "./Vip.vue?vue&type=template&id=f8ff6ac6&scoped=true&"
import script from "./vip.js?vue&type=script&lang=js&"
export * from "./vip.js?vue&type=script&lang=js&"
import style0 from "./vip.scss?vue&type=style&index=0&id=f8ff6ac6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ff6ac6",
  null
  
)

export default component.exports